const Flickity = require('flickity');

export function carousel() {
  const elem = document.querySelectorAll('.js-carousel');
  for (let i = 0; i < elem.length; i++) {
    const el = elem[i];
    if(el){
      new Flickity(el, {
        // options
        cellAlign: 'left',
        contain: false,
        cellSelector: '.js-cell',
        cellAlign: 'left',
        wrapAround: true,
        setGallerySize: false,
        autoPlay: 5000,
        prevNextButtons: true,
        pageDots: true
      });
    }
  }
}